(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3332],{

/***/ 3332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WhyUs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43946);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




function WhyUs() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: ` relative ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description)}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center py-6 px-2 lg:p-16 gap-16 flex-col lg:flex-row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "lg:w-1/2 ",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-3xl mb-6",
                            children: "Water Contamination at Camp Lejeune"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-lg font-light",
                            children: "The water supply at Camp Lejeune was contaminated with high levels of toxic chemicals, including benzene, trichloroethylene (TCE), tetrachloroethylene, perchloroethylene (PCE), and vinyl chloride. These chemicals are known to cause cancer. The contamination occurred through various means, such as leaks from garbage dumps and underground storage tanks that allowed the chemicals to enter the water system. Even though the tanks were shut down in February 1985, those exposed to the toxic water still suffer from severe and sometimes life-threatening illnesses."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[300px] h-[270px] lg:w-[548px] lg:h-[465px] relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/topcamplejeunelawyers/assets/images/lawsuit.jpg",
                        layout: "fill",
                        alt: "waste"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 43946:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__vgkAy"};

/***/ })

}]);